export default __webpack_public_path__ + "static/media/gatsby.b38f0d41.png";